var _path, _path2, _path3, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-list",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5295",
    "data-name": "Path 5295",
    d: "M7,6H23a1,1,0,0,0,0-2H7A1,1,0,0,0,7,6Z",
    transform: "translate(0 -3)",
    fill: "#bbc6d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5296",
    "data-name": "Path 5296",
    d: "M23,11H7a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z",
    transform: "translate(0 -3)",
    fill: "#bbc6d1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5297",
    "data-name": "Path 5297",
    d: "M23,18H7a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z",
    transform: "translate(0 -3)",
    fill: "#bbc6d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#bbc6d1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 7)",
    fill: "#bbc6d1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 14)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrList);
export default __webpack_public_path__ + "static/media/fi-rr-list.3f6f6bdc.svg";
export { ForwardRef as ReactComponent };